// import ProductCardLink from './link';

import { ProductCardProps } from './types';

import ProductCardWithButton from './product-card-with-button';
import ProductCardParent from './product-card-parent';

// refactored due to the unwieldy giant component it used to be and the poor SEO.
const ProductCardComponent = (props: ProductCardProps) => {
	const {
		isParent = false,
		title,
		slug,
		hasButton = true,
	} = props;

	if (isParent || !slug) {
		return (
			<ProductCardParent
				{...props}
			/>
		);
	}

	return (
		<ProductCardWithButton
			hasButton={hasButton}
			{...props}
		/>
	);
};

export default ProductCardComponent;